import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import RawHtml from '../RawHtml/RawHtml';
import HelpButtons from './HelpButtons';
import useStyles from './Help.styles';
import { useLoaded } from '../MainContent/useComponentLoading';
const Help = (props) => {
    const { title, body, email, isCorporateEmail = false } = props;
    const { headingTag = 'H2' } = props;
    const { classes } = useStyles();
    const HeadingTag = headingTag.toLowerCase();
    useLoaded(props);
    return (_jsxs(_Fragment, { children: [title && _jsx(HeadingTag, { className: classes.title, children: title }), _jsx(RawHtml, { className: classes.body, content: body }), _jsx(HelpButtons, { email: email, isCorporateEmail: isCorporateEmail, classNames: classes })] }));
};
export default Help;
